import {loadNews, AgentNewsActionType, getNews} from 'Agent/AgentInformation/ducks/news';
import {NewsEntry} from 'Agent/AgentInformation/models/NewsEntry';
import * as NewsApi from 'AgentNewsAdministration/api/agentNewsApi';
import {AsyncResult, fromResult} from 'Core/models/Async';
import {Page} from 'Core/models/Page';
import * as E from 'fp-ts/lib/Either';
import {pipe} from 'fp-ts/lib/pipeable';
import {all, call, put, takeLatest} from 'redux-saga/effects';
import {mergeWithNextPage} from 'Shared/utilities/PageUtility';

function* getNewsSaga() {
  yield takeLatest(AgentNewsActionType.GET_NEWS, function*(action: ReturnType<typeof getNews>) {
    const {page} = action.payload;

    const result: AsyncResult<Page<NewsEntry>> = yield page
      ? call(mergeWithNextPage, {existingPage: page})
      : call(NewsApi.getAgentNews);

    yield pipe(
      result,
      E.map(fromResult),
      E.fold(
        value => put(loadNews(value)),
        value => put(loadNews(value))
      )
    );
  });
}

export default function*() {
  yield all([getNewsSaga()]);
}
